import { broadCastConstant } from 'Constants/adminBroadCast.constants';
import Request from 'Services/request';
import broadCastSample from '../Dummy/broadCastSample'
import { alterQueryRequest,  findCurrentPageRequest, queryParser } from 'Helpers/urlform'
import { toast as toastr } from 'react-toastify';
import { handleApiError, AESdecrypt } from 'Helpers/index';
import {  formatDateTime } from 'Components/Common/TimeStamp';

const requestBroadCast = broadCast =>({ 
    type: broadCastConstant.BROADCAST_REQUEST, 
    broadCast 
})

const successBroadCast = broadcastDetails =>({
    type: broadCastConstant.BROADCAST_GET_SUCCESS,
    broadCast:broadcastDetails.data,
    totalRecords:broadcastDetails.count,
    currentPage:broadcastDetails.currentPage
})

const successUpdateBroadCast = broadcastDetails =>({
  type: broadCastConstant.UPDATE_BROADCAST_SUCCESS,
  broadCast:broadcastDetails
})

const failureBroadCast = error =>({
    type: broadCastConstant.BROADCAST_FAILURE,
    error
})

function dummyFetchBroadCast(params) {
   return new Promise((resolve,reject)=>{
       resolve(broadCastSample)
   })
}

function dummyUpdateBroadCast(){
  return new Promise((resolve,reject)=>{
     resolve(broadCastSample)
 })
}

function fetchBroadCast(SearchArray) {
  let url = '/broadcast';
  if(SearchArray && SearchArray.length > 0 ) {
    url = queryParser(url,SearchArray);
  }  
  const currentPage = findCurrentPageRequest(SearchArray);
  return async (dispatch) => {
    dispatch(requestBroadCast({}));
    await Request.get(url, {} ).then(( response ) => {
        const { data = [],count } = response;
        dispatch(successBroadCast({ data, count, currentPage }));
      })
      .catch((error) => {
        if(error) {
          handleApiError(error);
          dispatch(failureBroadCast(error.toString()));
        }
      });
  };
}

function addBroadCast(addBroadCastObj) {
    return (dispatch) => {
      dispatch(requestBroadCast({}));
      Request.create('/broadcast',{ ...addBroadCastObj })
      .then((response) => {
        const { message } = response;   
        dispatch(fetchBroadCast([]));
        toastr.success(message);
      })
      .catch((error) => {
        if(error) {
          handleApiError(error);
          dispatch(failureBroadCast(error.toString()));
        }
      });
    };
  }

  function updateBroadCast(broadCast) {
    const { id, ...rest } = broadCast
    return (dispatch) => {
      dispatch(requestBroadCast({}));
      Request.update(`/broadcast/${ id }`,
        { ...rest })
        dummyUpdateBroadCast()
        .then((response) => {
          const { message } = response;        
          dispatch(successUpdateBroadCast(broadCast));
          toastr.success(message);
        })
        .catch((error) => {
          if(error) {
            handleApiError(error);
            dispatch(failureBroadCast(error.toString()));
          }
        });
    };
  }

  function deleteBroadCast(id, SearchArray, remainningRecords){
    const updateSearchArray = alterQueryRequest(SearchArray, remainningRecords);
      return (dispatch) => {
          dispatch(requestBroadCast({}));
          Request.remove(`/broadcast?id=${ id }`,
          { id })
          .then((response) => {
            dispatch(fetchBroadCast(updateSearchArray));
            toastr.success('Deleted broadcast successfully');
          })
          .catch((error) => {
            if(error) {
              handleApiError(error);
              dispatch(failureBroadCast(error.toString()));
            }
          });
      }
  }

  const requestBroadcastExportData = exportData => ({
    type: broadCastConstant.EXPORT_BROADCAST_REQUEST, 
    exportData
  })
  
  const successBroadcastExportData = exportDataObj => ({
    type: broadCastConstant.EXPORT_BROADCAST_SUCCESS,
    exportData: exportDataObj.data,
    totalRecords: exportDataObj.count
  })
  
  const failureBroadcastExportData = error => ({
    type: broadCastConstant.EXPORT_BROADCAST_FAILURE,
    error
  })

  function exportBroadcast(SearchArray) {
    let url = '/broadcast';
    if (SearchArray && SearchArray.length > 0) {
      url = queryParser(url, SearchArray);
    }
    const exportUrl = SearchArray && SearchArray.length > 0 ? `&exportType=true` : `?exportType=true`;
    
    url = `${ url }${ exportUrl }`;
    return async (dispatch) => {
      dispatch(requestBroadcastExportData({}));
      await Request.get(url, {})
      //.then(response => response.json())
      .then(res => {
        const { data = [], count = 10 } = res;
        const dataToUpdate = [];
        data.forEach(function(res){
          const resObj = {};
          const decryptedMessage = JSON.parse(AESdecrypt(res.messages, res.messageId));
          const message = decryptedMessage.message || ''; 
          const createdAt = formatDateTime(res.createdDate); 
          resObj[ 'Messages' ] = message.trimLeft();
          resObj[ 'Messages Type' ] = res.messageType;
          resObj[ 'Team Name' ] = res.teamName;
          resObj[ 'Created By' ] = res.createdBy;
          resObj[ 'Broadcasted Date & Time' ] = createdAt && createdAt;
          resObj[ 'Delivered Status' ] = res.deliveredStatus === 1 ? 'Sent' : 'Failed';
          dataToUpdate.push(resObj);
        });
        dispatch(successBroadcastExportData({ data: dataToUpdate, count }));
      })
      .catch((error) => {
        if(error) {
          handleApiError(error);
          dispatch(failureBroadcastExportData(error.toString()));
        }
      });
    };
  }
  
  export const broadCastActions = {
    fetchBroadCast,
    addBroadCast,
    updateBroadCast,
    deleteBroadCast,
    exportBroadcast,
  };